import axios from 'axios'
import * as Util from '@/vuex/util'

let startState = {}

const state = {
  who: startState
}

const mutations = {
  FETCH (state, filters) {
    axios.get(Util.makeApiFilterUrl('/who', filters)).then(function (response) {
      state.who = response.data
    }).catch(function (error) {
      console.log(error)
    })
  },

  RESET (state) {
    state.who = startState
  }
}

const actions = {
  fetch: function ({commit}, filters) {
    commit('FETCH', filters)
  },

  reset: function ({commit}) {
    commit('RESET')
  }
}

const getters = {
  get: state => state.who
}

export const Who = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/tables/Who.js